import React, { useEffect } from "react";

function CountdownTimer({ timeLeft, setTimeLeft, label }) {
  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, setTimeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="text-xl font-mono text-center">
      {label}: {minutes}:{seconds.toString().padStart(2, "0")}
    </div>
  );
}

export default CountdownTimer;
